;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputDate', inputDate)

  /* @ngInject */
  function inputDate () {
    return {
      restrict: 'EA',
      scope: {
        label: '@',
        description: '@',
        placeholder: '@',
        modelPropertyName: '@',
        model: '=',
        value: '<',
        disabled: '<',
        pricing: '<',
        pricingTooltip: '<',
        pricingTooltipPosition: '<',
        readOnly: '<',
        mandatory: '<',
        format: '<',
        maxView: '<',
        minDate: '<',
        maxDate: '<',
        keyboard: '<',
        change: '=',
        greatThanEqual: '<'
      },
      templateUrl: '/core/directives/input-date/input-date-directive.html?$$REVISION$$',
      controller: 'InputDateController'
    }
  }
})()
